import { Card, CardContent, CardHeader, FormLabel, Grid, Grid2, MenuItem, Select, TextField } from "@mui/material";
import { JENJANG_TUJUAN, KELAS_TUJUAN } from "../../helper/Constant";
import { useEffect, useState } from "react";
import { Commons } from "../../helper/CommonService";

function DataTujuan({ handleChange, data }) {
    const [kelas, setKelas] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [programData, setProgramData] = useState([]);
    
    const ListKelas = (jenjangTujuan, programData) => {
        if(!programData) {
            programData = programs;
        }
        const findKelas = programData.find(item => item.nama_program === jenjangTujuan);
        let kelasArray = [];
        if (findKelas && findKelas.kelas_program) {
            kelasArray = findKelas.kelas_program.map(item => item.kelas);            
        }
        setKelas(kelasArray);
    }
    useEffect(() => {
        if (data && data.jenjang_tujuan) {
            const fetchPrograms = async () => {
                const programData = await Commons.GetAdditionalInformation("programs");
                const listJenjangTujuan = programData.map(item => item.nama_program);
                setProgramData(programData);
                setPrograms(listJenjangTujuan || []);
                ListKelas(data.jenjang_tujuan, programData);
            };
            fetchPrograms();
        }
    }, []);
    return (
        <>
            <Card>
                <CardHeader title="Data Tujuan" sx={{ borderBottom: "1px solid #f4f4f4" }}>
                </CardHeader>
                <CardContent>
                    <Grid sx={{ padding: "10px" }} container spacing={2}>
                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={6} xl={6} lg={6}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Jenjang Tujuan</FormLabel>
                            <Select required name="jenjang_tujuan" value={data?.jenjang_tujuan} onChange={(e) => {
                                handleChange(e.target.name, e.target.value);
                                ListKelas(e.target.value,programData);
                            }} fullWidth>
                                {
                                    Object.entries(programs).map(([key, tujuan]) => {
                                        return (
                                            <MenuItem key={key} value={tujuan}>{tujuan}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                        <Grid sx={{ padding: "5px" }} xs={12} sm={12} md={6} xl={6} lg={6}>
                            <FormLabel sx={{
                                color: "#000000", fontWeight: "bold", marginTop: "15px",
                                "::after": {
                                    content: '" *Wajib Diisi"',
                                    color: "red",
                                    fontWeight: "bold",
                                    fontStyle: "italic"
                                }
                            }}>Kelas Tujuan</FormLabel>
                            <Select required name="kelas_tujuan" value={data?.kelas_tujuan} onChange={(e) => { handleChange(e.target.name, e.target.value) }} fullWidth>
                                {
                                    Object.entries(kelas).map(([key, kelasValue]) => {
                                        console.log(kelasValue);
                                        return (
                                            <MenuItem key={key} value={kelasValue}>{kelasValue}</MenuItem>
                                        )
                                    })
                                }
                            </Select>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

        </>
    );
}

export default DataTujuan;